import { RestClient, RestRequest, RestResponse } from '../../../base';
import { ClientConfig } from '../../../config';
import {
  BatchDownloadCreateRequest,
  BatchDownloadCreateResponse,
  BatchDownloadStatusResponse,
  FileDeletionReportSubmitRequest,
  FileDeletionReportSubmitResponse,
  FileRegisterRequest,
  FileRegisterResponse,
  FileRegistrationReportSubmitRequest,
  FileRegistrationReportSubmitResponse,
} from './type';

// 싱글톤 RestClient 캐싱 (endpoint별)
const restClientCache: Map<string, RestClient> = new Map();

function getRestClient(endpoint: string): RestClient {
  let client = restClientCache.get(endpoint);
  if (!client) {
    client = new RestClient(endpoint);
    restClientCache.set(endpoint, client);
  }
  return client;
}

class ResourceProcessor {
  public constructor() {}

  private getEndpoint(): string {
    return ClientConfig.instance.getResourceEndpoint();
  }

  private getClient(): RestClient {
    return getRestClient(this.getEndpoint());
  }

  public __hidden__post__(restRequest: RestRequest): Promise<RestResponse> {
    return this.getClient().post(restRequest);
  }

  public __hidden__get__(restRequest: RestRequest): Promise<RestResponse> {
    return this.getClient().get(restRequest);
  }

  public __hidden__put__(restRequest: RestRequest): Promise<RestResponse> {
    return this.getClient().put(restRequest);
  }

  public async submitRegistrationReport(
    request: FileRegistrationReportSubmitRequest
  ): Promise<FileRegistrationReportSubmitResponse> {
    let retVal: FileRegistrationReportSubmitResponse = {
      isSuccess: false,
    };

    const restRequest = new RestRequest();
    restRequest.uri = `/resource/reports/registration/`;
    restRequest.data = request;
    let restResponse: RestResponse = await this.__hidden__post__(restRequest); //await RestProxy.post(restRequest)
    if (restResponse.isSuccess) {
      retVal.isSuccess = true;
      retVal.data = restResponse.data;
    }

    return retVal;
  }

  public async register(
    request: FileRegisterRequest
  ): Promise<FileRegisterResponse> {
    let retVal: FileRegisterResponse = {
      isSuccess: false,
    };

    const restRequest = new RestRequest();
    restRequest.uri = `/resource/files/`;
    restRequest.data = request;
    let restResponse: RestResponse = await this.__hidden__post__(restRequest); //await RestProxy.post(restRequest)
    if (restResponse.isSuccess) {
      retVal.isSuccess = true;
      retVal.data = restResponse.data;
    }

    return retVal;
  }

  public async createBatchDownload(
    request: BatchDownloadCreateRequest
  ): Promise<BatchDownloadCreateResponse> {
    let retVal: BatchDownloadCreateResponse = {
      isSuccess: false,
    };

    const restRequest = new RestRequest();
    restRequest.uri = `/resource/batch-downloads`;
    restRequest.data = request;
    let restResponse: RestResponse = await this.__hidden__post__(restRequest);
    if (restResponse.isSuccess) {
      retVal.isSuccess = true;
      retVal.data = restResponse.data;
    }

    return retVal;
  }

  public async getBatchDownloadStatus(
    requestId: string
  ): Promise<BatchDownloadStatusResponse> {
    let retVal: BatchDownloadStatusResponse = {
      isSuccess: false,
    };

    const restRequest = new RestRequest();
    restRequest.uri = `/resource/batch-downloads/${requestId}/status`;
    let restResponse: RestResponse = await this.__hidden__get__(restRequest);
    if (restResponse.isSuccess) {
      retVal.isSuccess = true;
      retVal.data = restResponse.data;
    }

    return retVal;
  }

  public async submitDeletionReport(
    request: FileDeletionReportSubmitRequest
  ): Promise<FileDeletionReportSubmitResponse> {
    let retVal: FileDeletionReportSubmitResponse = {
      isSuccess: false,
    };

    const restRequest = new RestRequest();
    restRequest.uri = `/resource/reports/deletion/`;
    restRequest.data = request;
    let restResponse: RestResponse = await this.__hidden__post__(restRequest); //await RestProxy.post(restRequest)
    if (restResponse.isSuccess) {
      retVal.isSuccess = true;
      retVal.data = restResponse.data;
    }

    return retVal;
  }
}

export { ResourceProcessor };
